import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  set_pageNavigator2tlfgk6pqrj4q as set_pageNavigator,
  get_pageNavigatorp3to6r4j8ctv as get_pageNavigator,
  _get_pageNavigator_$ref_twffzs1y4q72w3j5wfo as _get_pageNavigator_$ref_twffzs,
  _set_pageNavigator_$ref_jevpp01gsvioa3u4qpr as _set_pageNavigator_$ref_jevpp0,
} from './Navigator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_mainPageNavigator(_this__u8e3s4, _set____db54di) {
  _init_properties_deprecated_kt__373bhv();
  var tmp0 = mainPageNavigator$delegate;
  var tmp = KMutableProperty1();
  var tmp_0 = _get_mainPageNavigator_$ref_hg1lg1();
  // Inline function 'kotlin.setValue' call
  getPropertyCallableRef('mainPageNavigator', 1, tmp, tmp_0, _set_mainPageNavigator_$ref_nlnxvp());
  tmp0.set(_this__u8e3s4, _set____db54di);
  return Unit_instance;
}
function get_mainPageNavigator(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  var tmp0 = mainPageNavigator$delegate;
  var tmp = KMutableProperty1();
  var tmp_0 = _get_mainPageNavigator_$ref_hg1lg1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('mainPageNavigator', 1, tmp, tmp_0, _set_mainPageNavigator_$ref_nlnxvp());
  return tmp0.get(_this__u8e3s4);
}
var mainPageNavigator$delegate;
var screenNavigator$delegate;
var mainScreenNavigator$delegate;
function set_pageNavigator_0(_this__u8e3s4, value) {
  _init_properties_deprecated_kt__373bhv();
  set_pageNavigator(_this__u8e3s4.get_context_h02k06_k$(), value);
}
function get_pageNavigator_0(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  return get_pageNavigator(_this__u8e3s4.get_context_h02k06_k$());
}
function set_mainPageNavigator_0(_this__u8e3s4, value) {
  _init_properties_deprecated_kt__373bhv();
  set_mainPageNavigator(_this__u8e3s4.get_context_h02k06_k$(), value);
}
function get_mainPageNavigator_0(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  return get_mainPageNavigator(_this__u8e3s4.get_context_h02k06_k$());
}
function _get_mainPageNavigator_$ref_hg1lg1() {
  return constructCallableReference((p0) => get_mainPageNavigator(p0), 1, 0, 98);
}
function _set_mainPageNavigator_$ref_nlnxvp() {
  return constructCallableReference((p0, p1) => {
    set_mainPageNavigator(p0, p1);
    return Unit_instance;
  }, 2, 0, 99);
}
function _get_pageNavigator_$ref_twffzs_0() {
  return constructCallableReference((p0) => get_pageNavigator_0(p0), 1, 0, 100);
}
function _set_pageNavigator_$ref_jevpp0_0() {
  return constructCallableReference((p0, p1) => {
    set_pageNavigator_0(p0, p1);
    return Unit_instance;
  }, 2, 0, 101);
}
function _get_mainPageNavigator_$ref_hg1lg1_0() {
  return constructCallableReference((p0) => get_mainPageNavigator_0(p0), 1, 0, 102);
}
function _set_mainPageNavigator_$ref_nlnxvp_0() {
  return constructCallableReference((p0, p1) => {
    set_mainPageNavigator_0(p0, p1);
    return Unit_instance;
  }, 2, 0, 103);
}
var properties_initialized_deprecated_kt_8461sb;
function _init_properties_deprecated_kt__373bhv() {
  if (!properties_initialized_deprecated_kt_8461sb) {
    properties_initialized_deprecated_kt_8461sb = true;
    var tmp = KMutableProperty1();
    var tmp_0 = _get_pageNavigator_$ref_twffzs();
    mainPageNavigator$delegate = getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0());
    var tmp_1 = KMutableProperty1();
    var tmp_2 = _get_pageNavigator_$ref_twffzs_0();
    screenNavigator$delegate = getPropertyCallableRef('pageNavigator', 1, tmp_1, tmp_2, _set_pageNavigator_$ref_jevpp0_0());
    var tmp_3 = KMutableProperty1();
    var tmp_4 = _get_mainPageNavigator_$ref_hg1lg1_0();
    mainScreenNavigator$delegate = getPropertyCallableRef('mainPageNavigator', 1, tmp_3, tmp_4, _set_mainPageNavigator_$ref_nlnxvp_0());
  }
}
//region block: exports
export {
  get_mainPageNavigator as get_mainPageNavigator26bf0rvtlvnco,
  _get_pageNavigator_$ref_twffzs_0 as _get_pageNavigator_$ref_twffzs1xctzo7bzxnjn,
  _set_pageNavigator_$ref_jevpp0_0 as _set_pageNavigator_$ref_jevpp01vlvro7b3g4ux,
};
//endregion

//# sourceMappingURL=deprecated.mjs.map
